define('core/utils/threadRatingsHelpers',[
    'core/utils/object/get',
], function (
    get
) {
    'use strict';

    var exports = {};

    /**
     * Checks if star ratings is enabled for a thread.
     *
     * DO NOT USE WITH BACKBONE MODELS
     *
     * Must check if it's enabled on the thread, forum, and as a saas feature. All flags must be on
     * to show star ratings, but the BE doesn't change every flag when one changes.
     *
     * @param  {Object}  thread - the thread to check if ratings are enabled
     * @param  {Object}  forum - the thread's forum
     * @returns {boolean} - whether or not star ratings is enabled on the thread
     */
    exports.isThreadRatingsEnabled = function (thread, forum) {
        // Ensure thread's forum matches with passed forum
        if (!thread || !thread.forum || !forum || forum.id !== thread.forum)
            return false;

        return Boolean(get(thread, ['ratingsEnabled']) && get(forum, ['settings', 'threadRatingsEnabled']) &&
            get(forum, ['features', 'threadRatings']));
    };

    /**
     * Checks if star ratings is enabled for a thread.
     *
     * Must be used with a Backbone model. This is kept separate from `isThreadRatingsEnabled`
     * to keep each function simpler.
     *
     * Must check if it's enabled on the thread, forum, and as a saas feature. All flags must be on
     * to show star ratings, but the BE doesn't change every flag when one changes.
     *
     * @param  {Object}  thread - Backbone model for the thread to check if ratings are enabled
     * @returns {boolean} - whether or not star ratings is enabled on the thread
     */
    exports.isThreadModelRatingsEnabled = function (thread) {
        if (!thread || !thread.forum)
            return false;

        var forumSettings = thread.forum.get('settings');
        var forumFeatures = thread.forum.get('features');

        return Boolean(thread.get('ratingsEnabled') &&
            forumSettings && forumSettings.threadRatingsEnabled &&
            forumFeatures && forumFeatures.threadRatings);
    };

    /**
     * Checks if star ratings is enabled for a forum.
     *
     * DO NOT USE WITH BACKBONE MODELS
     *
     * Must check if it's enabled the forum and as a saas feature. Both flags must be on
     * to show star ratings, but the BE doesn't change both flags when one changes.
     *
     * @param  {Object}  forum - the forum to check if ratings are enabled
     * @returns {boolean} - whether or not star ratings is enabled on the forum
     */
    exports.isForumRatingsEnabled = function (forum) {
        if (!forum)
            return false;

        return Boolean(get(forum, ['settings', 'threadRatingsEnabled']) &&
            get(forum, ['features', 'threadRatings']));
    };

    /**
     * Checks if star ratings is enabled for a forum.
     *
     * Must be used with a Backbone model. This is kept separate from `isForumRatingsEnabled`
     * to keep each function simpler.
     *
     * Must check if it's enabled the forum and as a saas feature. Both flags must be on
     * to show star ratings, but the BE doesn't change both flags when one changes.
     *
     * @param  {Object}  forum - the forum to check if ratings are enabled
     * @returns {boolean} - whether or not star ratings is enabled on the forum
     */
    exports.isForumModelRatingsEnabled = function (forum) {
        if (!forum)
            return false;

        var forumSettings = forum.get('settings');
        var forumFeatures = forum.get('features');

        return Boolean(forumSettings && forumSettings.threadRatingsEnabled &&
            forumFeatures && forumFeatures.threadRatings);
    };

    return exports;
});

